import * as React from "react";
export function SvgSpacesMediumExternalServerCertified(
  props: React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg
      id="Spaces_Medium_External_Server_Certified_svg__Layer_1"
      x={0}
      y={0}
      width={24}
      height={24}
      xmlSpace="preserve"
      {...props}
    >
      <style>
        {".Spaces_Medium_External_Server_Certified_svg__st0{fill:#676767}"}
      </style>
      <path
        id="Spaces_Medium_External_Server_Certified_svg__Line3_3_"
        className="Spaces_Medium_External_Server_Certified_svg__st0"
        d="M16 15h2v1h-2z"
      />
      <path
        id="Spaces_Medium_External_Server_Certified_svg__Line2_3_"
        className="Spaces_Medium_External_Server_Certified_svg__st0"
        d="M16 10h2v1h-2z"
      />
      <path
        id="Spaces_Medium_External_Server_Certified_svg__Line1_3_"
        className="Spaces_Medium_External_Server_Certified_svg__st0"
        d="M18 5h-2v1h2z"
      />
      <path
        id="Spaces_Medium_External_Server_Certified_svg__ServerOutline_2_"
        className="Spaces_Medium_External_Server_Certified_svg__st0"
        d="M20 4c0-.6-.4-1-1-1H4c-.6 0-1 .4-1 1v4c0 .2.1.4.2.5-.1.1-.2.3-.2.5v4c0 .2.1.4.2.5-.1.1-.2.3-.2.5v4c0 .6.4 1 1 1h15c.6 0 1-.4 1-1v-4c0-.2-.1-.4-.2-.5.1-.1.2-.3.2-.5V9c0-.2-.1-.4-.2-.5.1-.1.2-.3.2-.5V4zM4 4h15v4H4V4zm15 9H4V9h15v4zm0 5H4v-4h15v4z"
      />
      <g>
        <circle
          id="Spaces_Medium_External_Server_Certified_svg__CircleBlue_26_"
          cx={18.5}
          cy={17.5}
          r={3.5}
          fill="#4bbc91"
        />
        <path
          id="Spaces_Medium_External_Server_Certified_svg__Check_5_"
          d="M20.5 16c-.2-.1-.4-.1-.6.1L18.4 18l-1.1-.8c-.2-.1-.4-.1-.5 0-.1.2-.1.5 0 .6l1.2.9c.5.4.6.3.9-.1l1.7-2.2c0-.1 0-.2-.1-.4z"
          fill="#fff"
        />
      </g>
    </svg>
  );
}
